import { ToolTypeService, ToolDescriptionByTypeService } from '../camtl.service';

export abstract class MasterToolListBase {
    constructor(public toolTypeService: ToolTypeService, public toolTypeDescription: string, toolDescriptionService: ToolDescriptionByTypeService) {
        var self = this;
        this.toolDescriptionService = toolDescriptionService;
    }

    system: any;
    toolDescriptionService: any;
    systemLayoutId: string = undefined;
    buildToolId: string = undefined;;
    furnishedId: string = undefined;;
    weldGunId: string = undefined;;
    legacyToolId: string = undefined;;


    getToolDescriptions(description: string) {
        var id;
        var self = this;
        this.toolTypeService.read()
            .then(function (response: any) {
                id = response.filter(function (item) {
                    return item.Description === description;
                })[0].Id;

                if (self.toolDescriptionService && id) {
                    self.toolDescriptionService.read("/" + id + '/toolDescription', true);
                }

            })
    }

}